import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { Observable, ReplaySubject, combineLatest } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Location, Room } from '@era/locations-sdk';

import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { CategoryStoreActions, CategoryStoreSelectors, DeviceStoreSelectors } from '@era/stores';
import { RoomSelectComponent } from './room-select.component';
import { AsyncPipe } from '@angular/common';
@Component({
  selector: 'era-room-select',
  templateUrl: './room-select.container.html',
  styleUrls: ['./room-select.container.scss'],
  imports: [RoomSelectComponent, ReactiveFormsModule, AsyncPipe],
})
export class RoomSelectContainerComponent implements OnChanges {
  @Input() location: Location;

  @Output() readonly roomChange = new EventEmitter<Room>();

  public readonly showRoomsWithDevicesForm: UntypedFormControl = new UntypedFormControl(false);
  public readonly rooms$: Observable<Room[]>;

  private readonly _location$ = new ReplaySubject<Location>(1);

  constructor(private readonly store: Store<Room>) {
    const showRoomsWithDevices$: Observable<boolean> = this.showRoomsWithDevicesForm.valueChanges.pipe(
      startWith(this.showRoomsWithDevicesForm.value),
      map((show) => (show ? true : false))
    );

    this.rooms$ = combineLatest([this._location$, showRoomsWithDevices$]).pipe(
      filter(([location]) => !!location),
      switchMap(([location, withDevices]) =>
        withDevices
          ? this.store.select(CategoryStoreSelectors.selectRoomsByLocationId(location.id))
          : this.store.select(DeviceStoreSelectors.selectRoomsByLocationWithoutAnyDevice(location.id))
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location) {
      if (this.location) {
        this.store.dispatch(
          CategoryStoreActions.CategoryResolverActions.categoriesRequested({
            categoryType: 'Room',
            locationId: this.location.id,
          })
        );
      }
      this._location$.next(this.location);
    }
  }

  selected(room: Room) {
    this.roomChange.emit(room);
  }
}
